module.exports = __webpack_public_path__ + "img/microplastics-5.6bccf365.png";